<template>
	<div class="o-wrap">
		<el-page-header @back="$router.go(-1)" content="留言管理" />
		<el-table :data="tableData" border>
			<el-table-column fixed prop="url" label="链接" />
			<el-table-column fixed prop="content" label="详情需求" />
			<el-table-column width="120" prop="name" label="姓名" />
			<el-table-column width="120" prop="phone" label="电话" />
			<el-table-column width="200" prop="time" label="时间" />
			<el-table-column width="200" label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
			}
		},
		created() {
			this.getData()
		},
		methods: {
			getData() {
				this.$axios.post('Myseller-setting-selectShopMessage', {
					user_id:this.$store.state.USER_ID,
				}).then(data => {
					console.log("data",data)
					if(data != null){
						this.tableData = data
					}
				})
			},
			handleDelete(row){
				//删除
				let a  = {
					user_id:this.$store.state.USER_ID,
					id:row.id,
				}
				this.$axios.post('Myseller-setting-delShopMessage',a).then(data => {
					this.$message.success('删除成功')
					this.getData()
				})
				
			},
		}
	}
</script>

<style scoped>
	.el-button+span {
		margin-left: 10px;
	}

	.el-pagination {
		text-align: center;
		margin-top: 20px;
	}
</style>
